"use client";

import { useEffect, useState } from "react";

export function useIsEmbedded() {
  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    const checkIsEmbedded = () => {
      try {
        // If window.self !== window.top, the page is in an iframe or embed
        if (window.self !== window.top) {
          setIsEmbedded(true);
        } else {
          setIsEmbedded(false);
        }
      } catch (e) {
        // If a cross-origin error occurs, assume the page is embedded
        setIsEmbedded(true);
      }
    };

    checkIsEmbedded();
  }, []);

  return isEmbedded;
}
